import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { AudioFile } from "@modules/audioFiles/types";
import { AudioFileFormValues } from "@modules/audioFiles/validations";
import { editAudioFileService } from "./service";
import { UseEditAudioFileMutationOptions } from "./types";

export function useEditAudioFileMutation(
  options?: UseEditAudioFileMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<AudioFile, ApiError, { id: string; data: AudioFileFormValues }>({
    mutationFn: ({ id, data }) => editAudioFileService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("v1/audiobook_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
